import { Component, OnInit } from '@angular/core';
import { ProductService } from '../../purchasing/products/product.service';
import { Product } from '../../purchasing/products/product';
import { Observable } from 'rxjs/Observable';
import { Branch } from '../../accounting/branch';
import { AuthenticationService } from '../../../shared/services/authentication.service';
import { LocationService } from 'services/location.service';
import { Location } from '@angular/common';
import { TdDialogService } from '@covalent/core';
import { InventoryService } from '../../inventory/inventory.service';
import { Piece } from '../../inventory/piece';
import { PrintingService } from '../../../shared/services/printing.service';

@Component({
  selector: 'app-import',
  templateUrl: './import.component.html',
  styleUrls: ['./import.component.scss'],
  providers: [PrintingService]
})
export class ImportComponent implements OnInit {
  products: Product[] = [];
  filteredProducts: Product[] = [];

  filteredCollections: string[] = [];
  filteredDesigns: string[] = [];
  filteredColors: string[] = [];

  filteredSupplierCollections: string[] = [];
  filteredSupplierDesigns: string[] = [];
  filteredSupplierColors: string[] = [];

  design_name: string;
  color_name: string;
  collection_name: string;
  supplier_design_name: string;
  supplier_color_name: string;
  supplier_collection_name: string;
  location: string;

  color: Product = new Product();
  branch_id: number;
  location_id: string;

  length: number;
  weight: number;

  locations: any[] = [];
  allBranches$: Observable<Branch[]>;

  constructor(private _productService: ProductService,
    private _authService: AuthenticationService,
    private _dialog: TdDialogService,
    private _printService: PrintingService,
    private _location: Location,
    private _inventoryService: InventoryService,
    private _locationService: LocationService,
  ) { }

  ngOnInit() {
    this.allBranches$ = this.allBranches$ = Observable.of(this._authService.getUserBranches());

    this.branch_id = this._authService.getHomeBranch();

    this._productService.getProducts().subscribe(
      (p: Product[]) => {
        this.products = p;

        // On init, we only populate the designs
        this.filterDesigns();
        this.filterSupplierDesigns();
      }
    );

    // Get locations for the specific branch
    this.getLocations();
  }

  filterDesigns() {
    this.filteredDesigns = Array.from(new Set(this.products.map(p => p.design_name)));    
  }

  filterColors() {
    this.filteredColors = Array.from(new Set(this.products.filter(p => { return p.design_name == this.design_name }).map(p => p.name)));

    this.filteredSupplierColors = Array.from(new Set(this.products.filter(p => { return p.design_name == this.design_name }).map(p => p.color_supplier_name)));    
  }

  filterCollections() {
    this.collection_name = '';
    this.filteredCollections = Array.from(new Set(this.products.filter(p => { return p.design_name == this.design_name && p.name == this.color_name }).map(p => p.collection_name)));

    if (this.filteredCollections.length == 1) {
      this.collection_name = this.filteredCollections[0];
      this.setColor();
    }
  }

  filterSupplierDesigns() {
    // Use supplier names
    //this.filteredDesigns = Array.from(new Set(this.products.map(p => p.design_name)));
    this.filteredSupplierDesigns = Array.from(new Set(this.products.map(p => p.design_supplier_name)));
  }

  filterSupplierColors() {
    //Use supplier colors
    //this.filteredColors = Array.from(new Set(this.products.filter(p => { return p.design_name == this.design_name }).map(p => p.name)));
    this.filteredSupplierColors = Array.from(new Set(this.products.filter(p => { return p.design_supplier_name == this.supplier_design_name }).map(p => p.color_supplier_name)));

    this.filteredColors = Array.from(new Set(this.products.filter(p => { return p.design_supplier_name == this.supplier_design_name }).map(p => p.name)));
  }

  filterSupplierCollections() {
    this.supplier_collection_name = '';
    
    // Use supplier collections
    //this.filteredCollections = Array.from(new Set(this.products.filter(p => { return p.design_name == this.design_name && p.name == this.color_name }).map(p => p.collection_name)));
    this.filteredSupplierCollections = Array.from(new Set(this.products.filter(p => { return p.design_supplier_name == this.supplier_design_name && p.color_supplier_name == this.supplier_color_name }).map(p => p.collection_supplier_name)));

    if (this.filteredSupplierCollections.length == 1) {
      this.supplier_collection_name = this.filteredSupplierCollections[0];
      this.setSupplierColor();
    }
  }
  
  setColor() {
    console.log(this.products);
    this.color = (this.products.find(p => { return p.collection_name == this.collection_name && p.design_name == this.design_name && p.name == this.color_name }) || new Product());
    console.log(this.color);
  }

  setSupplierColor() {
    console.log(this.products);
    this.color = (this.products.find(p => { return p.collection_supplier_name == this.supplier_collection_name && p.design_supplier_name == this.supplier_design_name && p.color_supplier_name == this.supplier_color_name }) || new Product());
    console.log(this.color);
  }

  getLocations() {
    if (this.branch_id) {
      this._locationService.getLocations(this.branch_id+'').subscribe(
        response => {
          this.locations = response;
        }
      );
    }
  }

  setLocation() {
    this.location_id = (this.locations.find(l => { return l.name == this.location }) || {})['id'];
  }

  setWeight() {
    this.weight = Number.parseFloat(((Number.parseFloat(this.color.weight_gsm) * Number.parseFloat(this.color.width) / 100000 * this.length) || 0).toFixed(2));

    this.weight = this.round(this.weight, 0.05);
  }

  round(value, step) {
    step || (step = 1.0);
    var inv = 1.0 / step;
    return Math.round(value * inv) / inv;
  }

  goBack() {
    this._location.back();
  }

  saveAndPrint() {
    if (this.branch_id == null) {
      this._dialog.openAlert({ title: 'Missing Branch', message: 'Please select Branch' });
      return;
    }

    if (this.color == null || this.color.id == null) {
      this._dialog.openAlert({ title: 'Invalid DESIGN/COLOR', message: 'Cannot find DESIGN/COLOR combination' });
      return;
    }

    if (this.location_id == null) {
      this._dialog.openAlert({ title: 'Invalid Location', message: 'Please select a valid location' });
      return;
    }

    if (this.length == null || this.length <= 0) {
      this._dialog.openAlert({ title: 'Invalid length', message: 'Length must be > 0' });
      return;
    }

    if (this.weight == null || this.weight <= 0) {
      this._dialog.openAlert({ title: 'Invalid weight', message: 'Weight must be > 0' });
      return;
    }

    this._inventoryService.importPiece(Object.assign(new Piece(), {
      color_id: this.color.id,
      length: this.length,
      weight: this.weight,
      location_id: this.location_id
    })).subscribe(
      response => {
        console.log(response);
        if (response && response.status == 'SUCCESS') {
          this.print(response['id']);
          this._dialog.openAlert({ title: 'SUCCESS', message: 'Piece ' + response.piece_number + ' imported successfully' });
        } else {
          this._dialog.openAlert({ title: 'ERROR', message: 'Failed to import piece' });
        }
      }
    );
  }

  print(piece_id: number) {
    let piece: Piece;

    this._inventoryService.getPiece(piece_id, false).subscribe(
      (response: Piece[]) => {
        if (Array.isArray(response) && response.length > 0) {
          piece = response[0];

          // Fill in the gaps from the product view
          this._productService.getOneProduct(piece.color_id + '').subscribe(
            (product: Product) => {
              if (product != null) {
                this._printService.print(
                  {
                    // TODO: maybe need to support both company names
                    company_name: 'Valmust', // Set in stone
                    collection: piece.collection_name,
                    design: piece.design_name,
                    part_number: piece.piece_number,
                    color: piece.color_name,
                    grade_cut: '',
                    lot_no: piece.lot_number,
                    meters: piece.length,
                    kilos: piece.weight,
                    composition: product.composition,
                    width: product.width,
                    weight: product.weight_gsm
                  }, this._authService.getPrinterId(), 1 , 'roll').subscribe(
                  response => {
                    if (response['status'] == 'SUCCESS') {
                      this._dialog.openAlert({
                        message: 'Sent to print queue!',
                        title: 'Success'
                      });
                    } else {
                      this._dialog.openAlert({
                        message: 'Could not send to print queue!',
                        title: 'Failed'
                      });
                    }
                  }
                  );
              } else {
                this._dialog.openAlert({
                  message: 'The product information could not be retrieved!',
                  title: 'Failed'
                });
              }
            }
          );
        } else {
          this._dialog.openAlert({
            message: 'The roll information could not be found!',
            title: 'Failed'
          });
        }
      }
    );
  }
}



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/agatextscreens/pda/import/import.component.ts